import type { ChartNestedSettingsSeriesMultipleProps } from "./ChartNestedSettingSeriesMultiple";
import { ChartNestedSettingSeriesMultiple } from "./ChartNestedSettingSeriesMultiple";
import ChartNestedSettingSeriesSingle from "./ChartNestedSettingSeriesSingle";

export type ChartNestedSettingSeriesProps =
  ChartNestedSettingsSeriesMultipleProps & {
    isDashboard: boolean;
  };

const ChartNestedSettingSeries = ({
  isDashboard,
  ...props
}: ChartNestedSettingSeriesProps) => {
  return isDashboard ? (
    <ChartNestedSettingSeriesMultiple {...props} />
  ) : (
    <ChartNestedSettingSeriesSingle {...props} />
  );
};

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default ChartNestedSettingSeries;
